import { Component, EventEmitter, Output } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-save-draft-confirmation',
  templateUrl: './save-draft-confirmation.component.html',
  styleUrls: ['./save-draft-confirmation.component.scss'],
})
export class SaveDraftConfirmationComponent {
  @Output() choice = new EventEmitter<boolean>();
  constructor(
    private dialogRef: MatDialogRef<SaveDraftConfirmationComponent>
  ) {}

  onSave(): void {
    this.choice.emit(true);
    this.dialogRef.close();
  }

  onDiscard(): void {
    this.choice.emit(false);
    this.dialogRef.close();
  }
}
